// extracted by mini-css-extract-plugin
module.exports = {"duration":"time-duration_duration__2iTkq","time":"time-duration_time__2HNys"};